import {
  Edit,
  ListButton,
  number,
  NumberInput,
  required,
  SaveButton,
  ShowButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

const EditToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Update" />
    <ShowButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const EditActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
    <ShowButton />
  </TopToolbar>
);

export const AccessLevelEdit = () => (
  <Edit
    actions={<EditActions />}
    title="Access Level"
    mutationMode="pessimistic"
  >
    <SimpleForm toolbar={<EditToolbar />}>
      <TextInput
        source="title"
        helperText="example: Gold"
        validate={required()}
      />
      <TextInput
        source="name"
        helperText="example: power-gold"
        validate={required()}
      />
      <NumberInput source="level" helperText="example: 1" validate={number()} />
    </SimpleForm>
  </Edit>
);
